import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
const firebaseConfig = JSON.parse(process.env.VUE_APP_FIREBASE);

const app = initializeApp(firebaseConfig);
getAnalytics(app);

export const db = getDatabase(app);

export const firestore = getFirestore(app);

export const auth = getAuth(app);